<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <ExcelImport
          :url-excel="urlExcel"
          :cancel-route="'/employees'"
          :uploading="uploading"
          :file="file"
          :disabled="hasValidationErrors"
          @file-select="handleFileSelect"
          @submit="submitImportData"
          @clear-file="handleClearFile"
        >
          <template #table>
            <ExcelImportListTable
              table-title="Danh sách nhân sự từ file excel"
              :items="importItems"
              :fields="fields"
              :uploading="uploading"
              :valid-count="validCount"
              :invalid-count="invalidCount"
              :current-page="currentPage"
              @update:currentPage="currentPage = $event"
            />
          </template>
        </ExcelImport>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import ExcelImport from '@/view/components/common/ExcelImport.vue';
import ExcelImportListTable from '@/view/components/common/ExcelImportListTable.vue';
import excelImportMixin from '@/view/mixins/excel-import.mixin';
import { URL_IMPORT_EMPLOYEE } from '@/utils/constants';

export default {
  mixins: [excelImportMixin],
  components: {
    ExcelImport,
    ExcelImportListTable,
  },
  data() {
    return {
      urlExcel: URL_IMPORT_EMPLOYEE,
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'code',
          label: 'Mã NV',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '5%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'fullName',
          label: 'Họ tên',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'storeName',
          label: 'Cửa hàng',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'jobTitleName',
          label: 'Chức vụ',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '20%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'username',
          label: 'Tài khoản',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'roleName',
          label: 'Quyền',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '15%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-center',
          thClass: 'text-center',
        },
        {
          key: 'errors',
          label: 'Chi tiết',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
          },
          tdClass: 'text-left',
        },
      ],
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Nhân sự', route: '/employees' },
      { title: 'Danh sách nhân sự', route: '/employees' },
      { title: 'Nhập nhân sự excel' },
    ]);
  },
  methods: {
    mapExcelDataToItems(excelData) {
      return excelData.map((element) => ({
        fullName: element['Tên Nhân Viên'],
        code: element['Mã Nhân Viên'],
        jobTitleName: element['Chức vụ'],
        storeName: element['Cửa hàng'],
        username: element['Tài khoản'],
        roleName: element['Quyền'],
        isValid: true,
        errors: [],
      }));
    },
    getValidationEndpoint() {
      return 'v1/employees/validate-import-excel';
    },
    getValidationPayload(importItems) {
      return {
        employees: importItems.map((item) => ({
          code: item.code,
          fullName: item.fullName,
          jobTitleName: item.jobTitleName,
          storeName: item.storeName,
          username: item.username,
          roleName: item.roleName,
        })),
      };
    },
    getSubmitEndpoint() {
      return 'v1/employees/bulk-create';
    },
    getSubmitPayload() {
      return {
        employees: this.importItems,
      };
    },
    getRedirectRoute() {
      return 'list-employee';
    },
    handleClearFile() {
      this.clearFiles();
    },
  },
};
</script>
